/* eslint-disable react/no-unused-prop-types */

import { FC } from 'react';
import { HStack, VStack } from '@chakra-ui/react';

import { PlansVariant } from '__generated__/GQL';
import SunshineTag from 'components/_core/SunshineTag';
import Text from 'components/_core/Text';
import { OnboardingPlanDisplay } from 'features/Onboarding/modules/PricingPlan/pages/PlanSelection/types';

import locales from '../../locales';
import { CellData } from '../../types';
import Cell from '../Cell';

interface RowProps {
  title: string;
  subtitle: string;
  isLast: boolean;
  onboardingPlans: OnboardingPlanDisplay[];
  variant: PlansVariant | null;
  isComing?: boolean;
  isNew?: boolean;
  getCellData: (plan: OnboardingPlanDisplay) => CellData;
}

const Row: FC<RowProps> = ({
  getCellData,
  isComing,
  isLast,
  isNew,
  onboardingPlans,
  subtitle,
  title,
  variant,
}) => (
  <>
    <HStack
      alignItems="center"
      borderBottom={isLast ? 0 : '1px solid '}
      borderColor="grey.2"
      paddingTop="0"
      position="relative"
      width="250px"
    >
      <VStack alignItems="flex-start" paddingY="space-16" position="relative">
        <Text
          fontWeight="weight-500"
          marginBottom="space-4"
          variant="secondary"
        >
          {title}
        </Text>
        <Text fontSize="sm" variant="light">
          {subtitle}
        </Text>
        {isNew ? (
          <SunshineTag colorScheme="green">{locales.new}</SunshineTag>
        ) : null}
        {isComing ? (
          <SunshineTag colorScheme="blue">{locales.isComing}</SunshineTag>
        ) : null}
      </VStack>
    </HStack>
    {onboardingPlans.map((onboardingPlan) => {
      const { asset, check, text } = getCellData(onboardingPlan);
      return (
        <Cell
          asset={asset}
          check={check}
          key={onboardingPlan.brandName + '-' + variant}
          label={text}
          withBorderBottom={!isLast}
        ></Cell>
      );
    })}
  </>
);

export default Row;
